import treeArticle from './tree'
export default treeArticle
